import { PodProvider } from '@/typings/pod/podProvider';
import api from './baseApi';

export const getMyProductBasesPod = async (): Promise<PodProvider[]> => {
    const response = await api.get('/PodProvider/MyProductBases');
    return response.data;
};

export const getPodProviderById = async (id: number): Promise<PodProvider> => {
    const response = await api.get(`/PodProvider/${id}`);
    return response.data;
};

export const getPodProvidersWithTemplates = async (stampCookie?: string): Promise<PodProvider[]> => {
    const response = await api.get('PodProvider/PodWithTemplates', { params: { stampCookie } });
    return response.data;
};
